export const icon = css`
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 0;
  fill: currentColor;
  pointer-events: none;
`

///////////////////////////////////////////////////////////////////////////////////

import { css } from 'styled-components'
